export const generateArticleSlug = (titleObj) => {
    if (!titleObj) return '';
    
    const title = typeof titleObj === 'object' 
        ? titleObj.en || titleObj.ua || ''
        : titleObj;
    
    if (!title) return '';
    
    return title
        .toLowerCase()
        .trim()
        .replace(/\s*-\s*/g, '-')
        .replace(/[^a-z0-9-]+/g, '-')
        .replace(/-+/g, '-')
        .replace(/^-+/, '')
        .replace(/-+$/, '');
};